import { Typography } from '@mui/material';

export const Logo: React.FC = () => {
  return (
    <Typography
      variant="h2"
      noWrap
      component="div"
      sx={{
        ml: 2,
        mr: 3,
        color: '#000000',
        fontWeight: 500,
        fontFamily: "'DM Serif Display', serif",
      }}
    >
      FoodSafetyPlan
    </Typography>
  );
};

export default Logo;
